import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'

import { Observable, debounceTime, map, of, switchMap, tap } from 'rxjs'
import { QuestionService } from 'src/services/question.service';
import { SharedDataService } from 'src/services/shared-data.service';
import { AppService } from '../app.service';
import { Questionnaire } from 'src/models/question.model';
import { QuestionnaireResponse } from 'src/models/questionnaire-response.model';

@Injectable({
    providedIn: 'root'
})
export class QuestionsResolver implements Resolve<boolean> {
    
    culture = $localize.locale;

    /**
     * Constructor
     */
    constructor(
        private _questionService: QuestionService,
        private _sharedDataService: SharedDataService,
        private _appService: AppService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const responseId = route.params['responseId']
        const isPreview = route.params['preview'] === 'preview' ? true : false

        // no need to fetch the response from the server if has already been fetched
        if(this._sharedDataService.questionnaireResponse && this._sharedDataService.questionnaireResponse.responseId === responseId) {
            return of(true)
        }

        return this._appService.fetchDataByResponseId(responseId, isPreview).pipe(
            tap(({ response, instrument, launch }) => {
                this._sharedDataService.instrument = instrument
                // this._sharedDataService.response = response
                this._sharedDataService.launch = launch
                this._sharedDataService.previewMode = isPreview
            }),
            debounceTime(120),
            switchMap(({ response, instrument, launch }) => {
                return this._questionService.getQuestionnaire(response.launchId, isPreview).pipe(
                    map((questionnaire: Questionnaire) => {
                        return {
                            response,
                            questionnaire
                        }
                    })
                )
            }),
            map(({ response, questionnaire }) => this._appService.combineQuestionnaireAndResponse(response, questionnaire)),
            map((questionnaireResponse: QuestionnaireResponse) => {
                this._sharedDataService.questionnaireResponse = questionnaireResponse
                return true
            })
        );
    }
}